import { FormControl, FormLabel, GridItem, Stack, Text } from '@chakra-ui/react';
import gql from 'graphql-tag';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FormLabelPendingIndicator } from '~components/ui/FormLabelPendingIndicator';
import { BurnInRefreshSection_DisplayFragment } from './__generated__/BurnInRefreshSection.graphql';
import { DisplayBurnInRefreshTime } from './DisplayBurnInRefreshTime';

interface Props {
  display: BurnInRefreshSection_DisplayFragment;
}

export function BurnInRefreshSection({ display }: Props) {
  const { t } = useTranslation();
  const [isPending, setIsPending] = useState(false);

  return (
    <GridItem colSpan={{ base: 8, md: 7 }}>
      <Stack direction="column" spacing="10">
        <FormControl>
          <FormLabel>
            {t('refreshSchedule')}
            <FormLabelPendingIndicator isPending={isPending} />
          </FormLabel>
          <Text color="gray.500" mb="4">
            {t('burnInRefreshText')}
          </Text>
          <DisplayBurnInRefreshTime display={display} onPendingChange={setIsPending} />
        </FormControl>
      </Stack>
    </GridItem>
  );
}

BurnInRefreshSection.graphql = {
  fragments: {
    BurnInRefreshSection_display: gql`
      fragment BurnInRefreshSection_display on Display {
        id
        ...DisplayBurnInRefreshTime_display
      }
    `,
  },
};
